module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel md-scrollbar md-theme-default",
    attrs: {
      "id": "tracking"
    }
  }, [_c('div', {
    staticClass: "md-layout-row heading"
  }, [(_vm.title) ? _c('h1', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s((_vm.stock.name) ? _vm.title + ' на складе "' + _vm.stock.name + '"' : _vm.title))]) : _vm._e()]), _c('md-content', {
    staticClass: "md-elevation-1",
    attrs: {
      "md-theme": "white"
    }
  }, [(_vm.stock.traking && Object.keys(_vm.stock.traking).length) ? _c('div', {
    staticClass: "md-flex",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('md-table', {
    attrs: {
      "md-theme": "white",
      "md-sort": "id",
      "md-sort-order": "asc"
    },
    scopedSlots: _vm._u([{
      key: "md-table-row",
      fn: function(ref) {
        var item = ref.item;

        return _c('md-table-row', {}, [_c('md-table-cell', {
          attrs: {
            "md-sort-by": "freight.id",
            "md-label": "ID"
          }
        }, [_vm._v(_vm._s(item.freight.id))]), _c('md-table-cell', {
          attrs: {
            "md-sort-by": "traking_number",
            "md-label": "Номер груза"
          }
        }, [_vm._v(_vm._s(item.traking_number))]), _c('md-table-cell', {
          attrs: {
            "md-sort-by": "responsible_login",
            "md-label": "Ответственный"
          }
        }, [_vm._v(_vm._s(item.responsible_login))]), _c('md-table-cell', {
          attrs: {
            "md-sort-by": "arrival",
            "md-label": "Прибыл"
          }
        }, [_vm._v(_vm._s((item.arrival == 1) ? 'Да' : 'Нет'))]), _c('md-table-cell', {
          attrs: {
            "md-sort-by": "loss",
            "md-label": "Убыл"
          }
        }, [_vm._v(_vm._s((item.loss == 1) ? 'Да' : 'Нет'))]), _c('md-table-cell', {
          attrs: {
            "md-sort-by": "arrival_date",
            "md-label": "Дата прибытия"
          }
        }, [_vm._v(_vm._s(item.arrival_date))]), _c('md-table-cell', {
          attrs: {
            "md-sort-by": "loss_date",
            "md-label": "Дата убытия"
          }
        }, [_vm._v(_vm._s(item.loss_date))]), _c('md-table-cell', {
          attrs: {
            "md-sort-by": "created_at",
            "md-label": "Дата записи"
          }
        }, [_vm._v(_vm._s(item.created_at))]), _c('md-table-cell', {
          attrs: {
            "md-sort-by": "updated_at",
            "md-label": "Дата обновления"
          }
        }, [_vm._v(_vm._s(item.updated_at))]), _c('md-table-cell', {
          staticClass: "action-container",
          attrs: {
            "md-label": "Действия"
          }
        }, [_c('span', [_c('md-button', {
          staticClass: "md-icon-button md-dense",
          attrs: {
            "to": {
              name: 'FreightsTracking',
              params: {
                freight_id: item.freight.id
              }
            }
          }
        }, [_c('md-icon', [_vm._v("place")])], 1), _c('md-tooltip', {
          attrs: {
            "md-direction": "top"
          }
        }, [_vm._v("Отслеживание груза")])], 1), _c('span', [(item.freight.deal_id) ? _c('md-button', {
          staticClass: "md-icon-button md-dense",
          attrs: {
            "to": {
              name: 'DealEdit',
              params: {
                dealid: item.freight.deal_id
              }
            }
          }
        }, [_c('md-icon', [_vm._v("content_paste")])], 1) : _vm._e(), _c('md-tooltip', {
          attrs: {
            "md-direction": "top"
          }
        }, [_vm._v("К заявке")])], 1)])], 1)
      }
    }]),
    model: {
      value: (_vm.stock.traking),
      callback: function($$v) {
        _vm.$set(_vm.stock, "traking", $$v)
      },
      expression: "stock.traking"
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-055c6100","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/stock/views/Tracking.vue
// module id = 1026
// module chunks = 0